<template>
  <div class="m-edition-section-content-info">
    <div class="m-edition-section-content-info-title">
      <h2>
        <span
          v-if="!showElementName"
          class="m-edition-section-content-info-subtitle-academy-name"
        >
          {{ $t(`mEditionInfo.${$route.meta.isEdition}`) }} /
        </span>
        <span v-if="showElementName">
          {{ element.titulo }} /
        </span>
        <span
          v-if="infoSubTitle && !showElementName"
          class="font-weight-bold"
        >
          {{ infoTitle }} /
        </span>
        <span class="font-weight-bold">
          {{ infoEdition }}
        </span>
      </h2>
      <a
        v-if="goBackText"
        href="#"
        @click.prevent="$router.go(-1)"
      >
        <i class="far fa-chevron-left"></i>
        {{ goBackText }}
      </a>
      <MoleculeEditionSectionContentInfoNodeActions
        v-if="countNodosActivos && showElementName"
        :element="element"
      />
    </div>
    <MoleculeEditionSectionContentSubMenu
      v-if="moleculeSubMenu !== null"
      :is="moleculeSubMenu"
    />
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionSectionContentInfo',

  components: {
    MoleculeEditionSectionContentInfoNodeActions: () => import('@/components/molecules/MoleculeEditionSectionContentInfoNodeActions')
  },

  props: {
    element: Object,
    goBackText: String,
    infoTitle: String,
    infoSubTitle: String,
    section: String,
    subject: String
  },

  data () {
    return {
      moleculeSubMenu: null
    }
  },

  computed: {
    countNodosActivos () {
      return this.$store.getters.getProyectNodesEnrollment.length
    },

    infoEdition () {
      return this.$route.meta.isEdition === 'asset'
        ? this.$store.getters.getSelectedNode.nombre
        : this.infoSubTitle
          ? this.infoSubTitle : this.infoTitle
    },

    showElementName () {
      return this.$route.meta.isEdition === 'asset'
    }
  },

  watch: {
    subject () {
      this.getSubmenu()
    }
  },

  created () {
    this.getSubmenu()
  },

  methods: {
    getSubmenu () {
      import(`@/components/molecules/MoleculeEdition${this.section}${this.subject}SubMenu`)
        .then(subMenu => {
          this.moleculeSubMenu = subMenu.default
        })
        .catch(error => {
          this.moleculeSubMenu = null
        })
    }
  }
}
</script>
